import { useState } from 'react';
import type { FAQ } from '@/mocks/faqs';

interface FAQAccordionProps {
  faqs: FAQ[];
}

const FAQAccordion = ({ faqs }: FAQAccordionProps) => {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggle = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <div className="space-y-3">
      {faqs.map((faq) => (
        <div
          key={faq.id}
          className="border border-background-200/70 rounded-lg overflow-hidden"
        >
          <button
            onClick={() => toggle(faq.id)}
            className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
          >
            <span className="font-medium text-foreground-900 pr-4 text-sm md:text-base">
              {faq.question}
            </span>
            <i
              className={`ri-arrow-down-s-line text-lg text-foreground-500 transition-transform duration-300 flex-shrink-0 ${
                openId === faq.id ? 'rotate-180' : ''
              }`}
            ></i>
          </button>
          <div
            className={`transition-all duration-300 overflow-hidden ${
              openId === faq.id ? 'max-h-96' : 'max-h-0'
            }`}
          >
            <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
              {faq.answer}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FAQAccordion;